module.exports = __webpack_public_path__ + "static/media/Logo-str-2.193ebada.png";